/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import { Box, Typography } from "@mui/material";
import React from "react";
import Sidebar from "../components/sidebar";
import { Link, useLocation } from "react-router-dom";
import { Engagement } from "../types/engagements";
import EngagementDropdown from "./engagementDropDown";
import { isUserCompliantWithTOSRequirements } from "../helpers/user";
import TermsAndConditionsPopup from "../pages/termsandconditions";

interface LayoutProps {
  children: React.ReactNode;
  pageTitle: string;
  parentUrl: string;
  parentPageName: string;
  type?: string;
  engagements?: Engagement[];
}

const Layout: React.FC<LayoutProps> = ({
  pageTitle,
  parentUrl,
  parentPageName,
  children,
  engagements,
  type,
}) => {
  const userCompliesWithTOS = isUserCompliantWithTOSRequirements();
  const path = useLocation();

  if (!userCompliesWithTOS) {
    return <TermsAndConditionsPopup />;
  }
  return (
    <Box
      key={path.key}
      sx={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: { xs: "column", md: "row", lg: "row" },
        gap: "3",
        overflowY: "hidden",
        overflowX: "hidden",
        height: "100vh",
      }}
    >
      <Sidebar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#f0f2f5",
            color: "#333",
            padding: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: type === "home" ? "flex-end" : "unset",
          }}
        >
          <Box sx={{ pr: type === "home" ? 4 : 0, display: "flex" }}>
            {parentPageName && (
              <>
                <Link to={parentUrl}>
                  <Typography
                    sx={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}
                  >
                    {parentPageName}
                  </Typography>
                </Link>
                <Typography sx={{ mx: 2, fontSize: "16px" }}> / </Typography>
              </>
            )}
            {engagements && engagements[0] && engagements[0].id && (
              <>
                <EngagementDropdown engagements={engagements} />
                <Typography sx={{ mx: 2, fontSize: "16px" }}> / </Typography>
              </>
            )}

            <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
              {pageTitle}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default Layout;
